export const formatFieldName = (field) => {
  if (!field || typeof field !== 'string') return '';

  return field
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatHistoryValue = (value) => {
  if (value === null || value === undefined) return '-';

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  return String(value);
};

export const getRelativeTime = (dateString) => {
  if (!dateString) return '';

  const now = new Date();
  const created = new Date(dateString);

  if (isNaN(created.getTime())) return '';

  const diffSeconds = Math.floor((now - created) / 1000);

  if (diffSeconds >= 86400) {
    return created.toLocaleString();
  }

  if (diffSeconds < 60) return `${diffSeconds} seconds ago`;
  if (diffSeconds < 3600)
    return `${Math.floor(diffSeconds / 60)} minutes ago`;

  return `${Math.floor(diffSeconds / 3600)} hours ago`;
};